'use client'

import { Pagination } from '@mui/material'
import { useRouter, useSearchParams } from 'next/navigation'
import { type ChangeEvent, useEffect, useState } from 'react'

interface PaginationProps {
  total: number
}

export default function PaginationProducts({ total }: PaginationProps) {
  const router = useRouter()
  const searchParams = useSearchParams()
  const params = new URLSearchParams(searchParams.toString())
  const currentPage = params.get('page') ?? '1'
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  function handlePageChange(_: ChangeEvent<unknown>, value: number) {
    const page = String(value)
    params.set('page', page)
    window.scrollTo({ top: 100, behavior: 'smooth' })

    router.push(`?${params.toString()}`, { scroll: false })
  }

  return (
    <Pagination
      count={total}
      onChange={handlePageChange}
      page={Number.parseInt(currentPage)}
      shape="rounded"
      sx={{
        '.MuiPaginationItem-root': {
          fontSize: '0.75rem',
          fontWeight: '700',
          color: '#656566',
          margin: '0',
          width: '0',
          height: '30px',

          '&.Mui-selected': {
            backgroundColor: 'transparent',
            border: '2px solid #748AF4',
            color: '#748AF4',
            borderRadius: '10px',
          },
        },
      }}
    />
  )
}
